import { render } from "./TenderDetail.vue?vue&type=template&id=5870d89d&scoped=true"
import script from "./TenderDetail.vue?vue&type=script&lang=js"
export * from "./TenderDetail.vue?vue&type=script&lang=js"

import "./TenderDetail.vue?vue&type=style&index=0&id=5870d89d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5870d89d"]])

export default __exports__